import { render } from "./App.vue?vue&type=template&id=db87f60a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=db87f60a&lang=css"

import exportComponent from "/Users/zonk/dev/projects/zoom_video_sdk_vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__